
import Progress from '../Tools/Progress';
import Logo from './Nav/Logo';
import Tabs from './Nav/Tabs';
import Timer from './Nav/Timer';
import Chapter from './Nav/Chapter';
import useCourse from './Hooks/useCourse';
import useCurrentSection from './Hooks/useCurrentSection';
import { useState, useEffect } from 'react';
import Slide from "@mui/material/Slide";
import FifplButton from './Nav/FifplButton';
import FreeButton from './Nav/FreeButton';
import SearchButton from './Nav/SearchButton';
import VirtualClassroom from '../Tools/VirtualClassroom';

export default function Nav({open, onClose}){

    const course = useCourse();

    const section = useCurrentSection();

    const [openChapters, setOpenChapters] = useState([]);

    useEffect(() => {

        setOpenChapters(section ? [section.chapter?.id] : [])

    }, [section])


    const toggleChapter = id => {
        let copy = [...openChapters];
        const index = copy.indexOf(id);
        if(index < 0) copy.push(id);
        else copy.splice(index, 1);
        return setOpenChapters(copy);
    }

    return <Slide direction="right" in={open} mountOnEnter unmountOnExit>

        <nav className='study-nav'>

            <Logo onClose={onClose}/>

            <Tabs />

            <article className='study-nav-box'>

                <p className='study-title'>{course.title}</p>

                {course.enrollment && <Progress value={course.enrollment.completion} />}

                {false && course.enrollment && <Timer enrollment={course.enrollment} />}

            </article>

            <FifplButton />

            <FreeButton />

            <VirtualClassroom url={course.enrollment?.virtualClassroomUrl} sx={{ mt: 1, ml: 1}} />

            <SearchButton />

            <section className='study-chapters'>

                {course.chapters.map(c => 
                    <Chapter 
                        key={c.id} 
                        chapter={c} 
                        open={openChapters.includes(c.id)}
                        onToggle={() => toggleChapter(c.id)}
                    />    
                )}

            </section>

        
        </nav>
    </Slide>
}



